import { useState } from 'react';
import { DevTool } from "@hookform/devtools";

import { steps } from './steps/data/data';

import Logo from './components/Logo';
import Button from './components/Button';
import Header from './components/Header'

import { useForm, FormProvider } from "react-hook-form"
function FacialMonographyForm() {
    // const { clearErrors, reset, trigger, watch, control, register, handleSubmit, formState: {
    //     errors
    // } } = useForm()
    const methods = useForm()

    const [activeStep, setActiveStep] = useState(0);
    const renderStep = (stepIndex) => {
        if (stepIndex >= 0 && stepIndex < steps.length) {
            return steps[stepIndex].component({});
        }
        return null;
    };

    const nextStep = async () => {
        const isValid = await methods.trigger();
        if (isValid) {
            methods.clearErrors();
            setActiveStep((prevStep) => {
                const nextStep = prevStep + 1;
                return nextStep >= steps.length ? prevStep : nextStep;
            });
        }
    };
    const handleCancelClick = () => {
        setActiveStep(0);
        methods.reset();
    }
    const handleBackClick = () => {
        methods.clearErrors();
        setActiveStep((prevStep) => Math.max(prevStep - 1, 0));
    };
    const onSubmit = (data) => {
        console.log(data)
    };



    return (
        <>
            <FormProvider {...methods}>
                <form
                    onSubmit={methods.handleSubmit(onSubmit)}
                >
                    <div className='flex justify-center items-center w-full h-screen p-10'>
                        <div className='bg-[rgb(55,55,55)] w-[390px] min-h-[700px] p-5 flex flex-col justify-between items-center'>
                            <div className='flex flex-col justify-start items-center w-full h-full'>
                                <Logo showLogo={steps[activeStep]?.showLogo} />
                                <Header
                                    showHeader={steps[activeStep]?.showHeader}
                                    backClick={handleBackClick}
                                    cancelClick={handleCancelClick}
                                />
                                {renderStep(activeStep)}
                            </div>
                            <Button btnText={steps[activeStep]?.buttonText} showButton={steps[activeStep]?.showButton} onClick={nextStep} buttonType={steps[activeStep]?.buttonType} />
                        </div>
                    </div>
                </form >
            </FormProvider>
            <DevTool control={methods.control} /> {/* set up the dev tool */}
        </>
    )
}

export default FacialMonographyForm;